module.exports = __webpack_public_path__ + "static/media/dress-5.e96cdfd4.jpg";